import Vue from "modules/vue_twemoji";
import Quest from "components/quest";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const $questContainer = document.querySelector(".js-quest");

if($questContainer) {
  new Vue({
    i18n: new VueI18n({
      locale: "en"
    }),
    el: $questContainer,
    render: h => h(Quest)
  });
}
